import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle2 } from 'lucide-react';
export function BonusSection() {
  const bonuses = ['Guía completa de Senna ADC', 'Guía completa de Twitch ADC', 'Guía completa de Ezreal ADC', 'Checklists imprimibles por campeón', 'Tablas rápidas de decisión'];
  return <section className="py-20 bg-gradient-to-b from-[#0d1117] to-[#1a1f2e] relative overflow-hidden" data-id="element-1">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-amber-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-2" />

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-3">
        <div className="text-center mb-12" data-id="element-4">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 border border-amber-500/40 text-amber-400 font-bold uppercase mb-6 animate-pulse" data-id="element-5">
            <Gift className="w-5 h-5" data-id="element-6" />
            Solo por hoy
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-7">
            Bonus <span className="text-amber-500" data-id="element-8">Gratis</span> Incluidos
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-9">
            Llevate todo este contenido extra sin costo adicional al ordenar
            hoy.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-10">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/pgpbaFjsxZSTDwKXPNMnAA/5c77952c-6383-43c6-87a3-41715d4deac1.png" alt="Bonus Pack League of Legends" className="w-full h-auto rounded-lg shadow-[0_0_40px_rgba(245,158,11,0.2)] hover:scale-[1.02] transition-transform duration-500 cursor-pointer" onClick={() => document.getElementById('comprar')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-12" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6" data-id="element-13">
            <div className="bg-[#0a0a0a]/50 p-8 rounded-2xl border border-amber-500/30 backdrop-blur-sm" data-id="element-14">
              <h3 className="text-2xl font-bold text-white mb-6 border-b border-gray-700 pb-4" data-id="element-15">
                Lo que te llevás GRATIS:
              </h3>
              <ul className="space-y-4" data-id="element-16">
                {bonuses.map((bonus, index) => <li key={index} className="flex items-center gap-3" data-id="element-17">
                    <CheckCircle2 className="w-6 h-6 text-amber-500 flex-shrink-0" data-id="element-18" />
                    <span className="text-lg text-gray-200 font-medium" data-id="element-19">
                      {bonus}
                    </span>
                  </li>)}
              </ul>
              <div className="mt-8 pt-6 border-t border-gray-700 text-center" data-id="element-20">
                <p className="text-amber-400 font-bold text-lg animate-pulse" data-id="element-21">
                  Valorado en $29.999 — Ahora $7.999
                </p>
                <p className="text-red-400 font-black text-sm uppercase tracking-widest mt-2 animate-pulse" data-id="element-22">
                  🔥 Últimos días de descuento 🔥
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}